import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { debounceTime, filter } from 'rxjs/operators';
import { RfqCacheService } from '../../../dashboard/rfq-cache.service';
import { AbstractControl, FormArray, FormControl, FormGroup, NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SearchService } from 'src/app/views/search/search/search.service';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { Page } from 'src/app/shared/models/page';
import { aboutDataType, AutoCompleteDataType, AutoCompleteSupplierProduct, Currency, quoteAttachmentType, quoteDeclineReasonType } from 'src/app/shared/models/settings.model';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { CookieService } from 'ngx-cookie-service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
// import { SupplierService } from '../../supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService } from '../../../dashboard/supplier/supplier-dashboard/supplier-dashboard.service';
import { SupplierService as ss } from 'src/app/views/settings/suppliers/supplier.service';
import { Supplier } from 'src/app/shared/models/supplier.model';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { QuoteService } from '../../../dashboard/quote/quote.service';
import { RfqGenerateFormService } from '../../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { MatSelectChange } from '@angular/material/select';
import { v4 as uuidv4 } from "uuid";
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';


@Component({
  selector: 'app-service-purchase-order-line-items',
  templateUrl: './service-purchase-order-line-items.component.html',
  styleUrls: ['./service-purchase-order-line-items.component.css']
})

export class ServicePurchaseOrderLineItemsComponent implements OnInit{
  @ViewChild('table') table!: DatatableComponent;
  serviceRfqId!: number;
  quoteId!: number;
  servicePurchaseOrderId!: number;
  isSaved: boolean = false;
  currentTab: string = 'line-items';
  tabEnabled: boolean = false;

  showConfirmationDialogue: boolean = false
  showSuccessDialogue: boolean = false
  showCloseDialogue: boolean = false;
  previewSection: boolean = false;
  previewDocs:any[]=[]
  currentIndex = 0;

  showCloseDialogueFreight: boolean = false;
  showFreightForwarderDialogue: boolean = false;
  freightForwarders:any[]=[]
  selectedFreightForwarder:any;

  // Freight forwarder selection helpers
  availableModes: any[] = [];
  allAvailableModes: any[] = [];
  availablePackaging: any[] = [];
  allAvailablePackaging: any[] = [];

  selectedModes: number[] = [];
  selectedPackaging: number[] = [];
  freightForwarderForm!: UntypedFormGroup;

  // Sub-sidebar state for adding Mode of Transport and Packaging
  currentSubForm!: string;
  showSubSidebar: boolean = false;
  modeOfTransportFormGroup!: UntypedFormGroup;
  packagingFormGroup!: UntypedFormGroup;

  tabs: any[] = [
    {
      index: 0,
      label: 'LINE ITEMS',
      icon: "directions_boat",
      route: 'line-items',
    },
    {
      index: 1,
      label: 'HEADER DETAILS',
      icon: "looks",
      route: 'header',
    },
    {
      index: 2,
      label: 'PAYMENT TERMS',
      icon: "location_searching",
      route: 'payment-terms',
    },{
      index:3,
      label: 'PREVIEW',
      icon: "location_searching",
      route: 'preview',
    }
  ];

  showNotification: boolean = false;
  notificationMessage: string = '';
  notificationTitle: string = '';
  notificationType: 'error' | 'info' = 'error';

  secondFormGroup!: UntypedFormGroup;
  declineFormGroup!: UntypedFormGroup;
  lineItemtableForm!: any;
  row: any = [];
  dataSource: any[] = [];
  headerData:any;
  showDeclineConfirmationDialogue:boolean=false
  showDetailSection: boolean = false;
  isWrapDescription: boolean = false;

  showAddDocumentSection: boolean = false;
  showAddCostSection: boolean = false;
  showDeclineSection: boolean = false;

  showOtherReason: boolean = false;

  displayedColumns = ['position', 'serviceName', 'serviceDescription',
     'buyerComment', 'supplierComment', 'uom', 'quantity',  'supplierUom', 'supplierQuantity',
     'unitCost', 'requestedUnitCost','discount', 'totalCost', 'requestedTotalCost','leadTime','attachments','delete'
  ];

  groupHeadersColumns = [
  'checkboxGroup',
  'positionGroup',
  'serviceNameGroup',
  'serviceDescriptionGroup',
  'buyerCommentGroup',
  'supplierCommentGroup',
  'attachmentsGroup',
  'uomQuantityGroup',
  'supplierUomQuantityGroup',
  'unitCostGroup',
  'discountGroup',
  'totalCostGroup',
  'leadTimeGroup',
  'deleteGroup'
];

  lineItemAttachmentTypeData:quoteAttachmentType[]=[]
  delineReasonData:quoteDeclineReasonType[]=[]

  selectedLineItemIndex!:number | null

  declineReason!:number | null
  otherReason:string=''

  freightDescription:string=''
  freightType:string='amount'
  freightValue!:number |null
  addedAdditionalCost:any[]=[]

  selectedAttachmentType!:number|null
  hazardousDeclaration!:number|null
  newfileuploaded:boolean=false;
  uploadedAttachmentsArray: any[] = [];
  acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  maxFileSize: number = 10 * 1024 * 1024; //10MB


  currentdate=new Date()
  taxStatusData:any[]=[]
  tableWidth = '100%';
  dynamicColumns = [
    // { key: 'buyerComment', name: 'Buyer Comment', visible: false },
    // { key: 'supplierComment', name: 'Supplier Comment', visible: false },
    // { key: 'quantity', name: 'Requested Quantity', visible: false },
    // { key: 'uom', name: 'Requested UOM', visible: false },
    // { key: 'unitCost', name: 'Unit Cost', visible: false },
    // { key: 'discount', name: 'Discount', visible: false },
    // { key: 'totalCost', name: 'Total Cost', visible: false },
    // { key: 'leadTime', name: 'Lead Time', visible: false },
    // { key: 'supplierUom', name: 'Supplier UOM', visible: false },
    // { key: 'supplierQuantity', name: 'Supplier Quantity', visible: false },
    { key: 'attachments', name: 'Attachments', visible: false },
    { key: 'requestedUnitCost', name: 'Requested Unit Cost', visible: false },
    { key: 'requestedTotalCost', name: 'Requested Total Cost', visible: false },
    // { key: 'delete', name: 'Delete', visible: false },
  ];

  showColumn(col:{ key: string; name: string; visible: boolean }) {
    col.visible = !col.visible;
    // this.tableWidth = 'max-content';
    // this.cdr.detectChanges();
    this.table.recalculate();
  }

  showToggleColumns(col:any){
    col.visible = !col.visible;
    this.table.recalculate();
  }

  getColumn(key: string) {
    return this.dynamicColumns.find(c => c.key === key);
  }

  boundGetCurrencyAutoComplete!: (pageMeta: Page) => Observable<any>;
  searchKeyParams: string = '';


  constructor(
    private snack: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private rfqCacheService: RfqCacheService,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private SettingsService: SettingsService,
    private fullLoaderService: FullLoaderService,
    private supplierService: SupplierService,
    private ss: ss,
    public dialog: MatDialog,
    private ls: LocalStoreService,
    private quoteService: QuoteService,
    private RfqGenerateFormService:RfqGenerateFormService,
    private cookieService: CookieService,
    private webApiService: WebApiService,
    private awsSdkService: AwsSdkService,
    private CookieService: CookieService
  ) {


    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([])
    });
  }

  // Rounds any numeric value to exactly 3 decimal places
  private round3(value: any): number {
    const n = Number(value) || 0;
    return Math.round((n + Number.EPSILON) * 1000) / 1000;
  }

  async ngOnInit() {
    this.fullLoaderService.showLoader();

    this.boundGetCurrencyAutoComplete =
    this.getCurrencyFilterKeyDataObservable.bind(this);

    this.getTaxDetails()


    this.secondFormGroup = this._formBuilder.group({

      quoteLineItemHeaderId:[null],
      quoteLineItemListPriceSubtotal:[null],
      quoteLineItemDiscount:[null],
      quoteLineItemSubtotal :[null],
      quoteLineItemGeneralDiscountType :['percentage'],
      quoteLineItemGeneralDiscountValue:[null],
      quoteLineItemFreightTotal:[null],
      quoteLineItemFreight:[null],
      quoteLineItemTotal :[null],
      supplierCurrency: [null],
      quoteLineItemApplicableTaxProfile: [null],
      quoteLineItemTaxAmount: [null],
    });

    this.lineItemtableForm = this._formBuilder.group({
      rows: this._formBuilder.array([]),
    });

    // Initialize Freight Forwarder form
    this.freightForwarderForm = this._formBuilder.group({
      freightForwarderId: [null, Validators.required],
      modeOfTransport: [null, Validators.required],
      packaging: [null, Validators.required],
      modeOfTransportId: [null, Validators.required],
      packagingId: [null, Validators.required]
    });

    // Initialize Sub-forms for adding Mode of Transport and Packaging
    this.modeOfTransportFormGroup = this._formBuilder.group({
      userId: Number(this.cookieService.get('userId')),
      freightForwarderId: [null],
      modeOfTransport: [null, Validators.required]
    });
    this.packagingFormGroup = this._formBuilder.group({
      userId: Number(this.cookieService.get('userId')),
      freightForwarderId: [null],
      packaging: [null, Validators.required]
    });

    this.lineItemAttachmentTypeData = await this.quoteService.fetchAllQuteAttachmentType('QuoteLineItemAttachmentType');

    this.delineReasonData = await this.quoteService.fetchAllDeclineReason();

    console.log(this.secondFormGroup.get('supplierCurrency')?.value);

    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['serviceRfqId'] != '' && params['quoteId'] != '' && params['servicePurchaseOrderId'] !=' ') {

        this.serviceRfqId = params['serviceRfqId']
        this.quoteId = params['quoteId']
        this.servicePurchaseOrderId = params['servicePurchaseOrderId']

        this.getQuoteDraftData()

      }
    })

    console.log(this.secondFormGroup.get('supplierCurrency')?.value);
    this.fetchRfqDetails()

    this.checkisTabEnabled()

    const result = await this.SettingsService.fetchFreightForwarderByUserId(
      Number(this.cookieService.get('userId'))
    );

    this.freightForwarders = result.rows;

    console.log('Freight Forwarders:', this.freightForwarders);

    // Load selectable options for Mode of Transport and Packaging
    await this.fetchModeofTransportByUserId();
    await this.fetchPackagingByUserId();

  }

  async confirmFreightForwarder(){
    // Basic validation for required fields
    if (!this.freightForwarderForm || this.freightForwarderForm.invalid) {
      this.snack.open('Please select Freight Forwarder, Mode of Transport and Packaging.', 'OK', { duration: 3000 });
      return;
    }

    const selectedFFId = this.freightForwarderForm.get('freightForwarderId')?.value;
    if (!this.selectedFreightForwarder || this.selectedFreightForwarder?.id !== selectedFFId) {
      this.selectedFreightForwarder = (this.freightForwarders || []).find((ff: any) => ff.id === selectedFFId);
    }

    console.log("selectedFreightForwarder",this.selectedFreightForwarder);
    this.showFreightForwarderDialogue=false;
    this.fullLoaderService.showLoader();
    let params={
      userId: Number(this.cookieService.get('userId')),
      purchaseOrderId:this.servicePurchaseOrderId,
      serviceRfqId:this.serviceRfqId,
      quoteId:this.quoteId,
      freightForwarderCompanyName:this.selectedFreightForwarder.freightForwarderCompanyName,
      emailID: this.selectedFreightForwarder.emailID,
      jobTitle: this.selectedFreightForwarder.jobTitle,
      phone: this.selectedFreightForwarder.phone,
      pic: this.selectedFreightForwarder.pic,
      address: this.selectedFreightForwarder.city,
      fax: this.selectedFreightForwarder.fax,
      packaging: this.freightForwarderForm.get('packaging')?.value,
      modeOfTransport: this.freightForwarderForm.get('modeOfTransport')?.value
    }
    await this.SettingsService.updateServicePurchaseOrderFreightForwarder(params);
    await this.getQuoteDraftData()
    this.fullLoaderService.hideLoader();
  }

  async save(isDraft?:boolean) {
    console.log("save is called")
    if(isDraft){
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    }


    this.fullLoaderService.showLoader()

    const params1 = {
      section: 'lineItems',
      // purchaseOrderStatus: isDraft? 14:2,
      purchaseOrderStatus: 14,
      purchaseOrderTabId:1,
      purchaseOrderId: this.servicePurchaseOrderId,
      quoteId: this.quoteId,
      serviceRfqId: this.serviceRfqId,
      userId: Number(this.cookieService.get('userId'))
    };

    await this.SettingsService.updateServicePurchaseOrder(params1);

    if(isDraft){
      this.router.navigate(['/operations/purchase-order-list'], {
        queryParams: {
          selectedStatus: 'Draft',
          label: 'Order'
        }
      });
      await this.getQuoteDraftData();
    }

    this.fullLoaderService.hideLoader()
  }


  async saveFreightForwarder(){
    this.showCloseDialogueFreight=false;
    this.showFreightForwarderDialogue = true;
  }

  isValidFreight(): boolean {
    const freightField = this.secondFormGroup.get('quoteLineItemFreight');

    // Check if freight details are provided
    if (!freightField?.value || freightField?.value.length === 0) {
      return false; // Return false if freight details are not provided
    }

    return true; // Return true if freight details are valid
  }

  async back() {

    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['serviceRfqId'] != '' && params['quoteId'] != '' ) {

        this.serviceRfqId = params['serviceRfqId']
        this.quoteId = params['quoteId']


        this.router.navigate([
          "dashboard", "quote", "create", 'header'
        ],
          {
            queryParams: { serviceRfqId: this.serviceRfqId, quoteId:this.quoteId }
          }
        );

    }})


  }
  closeLineItems(){
    this.router.navigate([
      "operations", "all-documents"
    ]
    );
  }
  async next() {

    // if (this.isSaved) {

    //   this.activatedRoute.queryParams.subscribe(async params => {


    //     if (params['serviceRfqId'] != '' && params['quoteId'] != '' ) {

    //       this.serviceRfqId = params['serviceRfqId']
    //       this.quoteId = params['quoteId']


    //       this.router.navigate([
    //         "dashboard", "quote", "create", 'payment-terms'
    //       ],
    //         {
    //           queryParams: { serviceRfqId: this.serviceRfqId, quoteId:this.quoteId }
    //         }
    //       );

    //   }})


    // }

    if (this.isSaved) {

      this.activatedRoute.queryParams.subscribe(async params => {

        if (params['serviceRfqId'] != '' && params['quoteId'] != '') {

          this.serviceRfqId = params['serviceRfqId']
          const quoteId = this.quoteId

          this.router.navigate([
            "dashboard", "quote", "create", 'header'
          ],
            {
              queryParams: { serviceRfqId: this.serviceRfqId, quoteId: quoteId }

            }
          );

        }

      })
    }
    // else{
    //   this.snack.open(`please save the 'Header' tab first`, "OK", { duration: 3000 });
    // }
  }

  // async close() {}

  calculateRowValues(index: number): void {

    const form = this.lineItemtableForm.get('rows') as FormArray;

    const row = form.at(index);

    console.log(index, row)
    if (!row) {
      console.error(`No row found at index ${index}`);
      return;
    }

    const quantity = parseFloat(row.get('supplierQuantity')?.value || '0');
    const unitCost = parseFloat(row.get('unitCost')?.value || '0');
    const discount = parseFloat(row.get('discount')?.value || '0');

    const discountedUnitPrice = this.round3(unitCost * (1 - discount / 100));
    const totalCost = this.round3(quantity * discountedUnitPrice);

    row.get('discountedUnitPrice')?.setValue(discountedUnitPrice, { emitEvent: false });
    row.get('totalCost')?.setValue(totalCost, { emitEvent: false });

    this.calculateCostSummary()

  }


  calculateCostSummary(){

      let subTotalCost = 0;
      let totalDiscount = 0;
      let totalUnitCost = 0;
      let totalCost = 0;
      let totalFreightAmount = 0;

      let taxPercentage = 0;
      let taxAmount = 0;

      const lineItemTable = this.lineItemtableForm.value;

      const row = lineItemTable.rows

      row.forEach((item: any) => {
        if (item.isActive === 1){

        const quantity = item.supplierQuantity || 0;
        const unitCost = item.unitCost || 0;
        const discount = item.discount  || 0;
        const discountedUnitPrice =  item.discountedUnitPrice || 0;


        const rowTotalCost = this.round3(discountedUnitPrice * quantity);
        const rowDiscount = this.round3(unitCost * (discount / 100) * quantity);
        const rowUnitCost = this.round3(unitCost * quantity);

        subTotalCost = this.round3(subTotalCost + rowTotalCost);
        totalDiscount = this.round3(totalDiscount + rowDiscount);
        totalUnitCost = this.round3(totalUnitCost + rowUnitCost);
        totalCost = this.round3(totalCost + rowTotalCost);
        }

    });



    if(this.secondFormGroup.get('quoteLineItemGeneralDiscountType')?.value != null ){

      const type = this.secondFormGroup.get('quoteLineItemGeneralDiscountType')?.value

      const genDiscount = parseFloat(this.secondFormGroup.get('quoteLineItemGeneralDiscountValue')?.value || '0');

      if (!isNaN(genDiscount) && genDiscount > 0) {
        if(type == 'percentage' ){
          const dec = this.round3((genDiscount / 100) * totalCost);
          totalCost = this.round3(totalCost - dec);
        }
        else{
          const dec = this.round3(genDiscount);
          totalCost = this.round3(totalCost - dec);
        }
      }
    }
    // if(this.secondFormGroup.get('quoteLineItemFreightTotal')?.value != null){

    //   const type = this.secondFormGroup.get('quoteLineItemFreightTotal')?.value

    //   const freight = parseFloat(this.secondFormGroup.get('quoteLineItemFreight')?.value || '0');

    //   if(type == 'percentage' ){
    //     totalCost += (freight / 100) * totalCost;
    //   }
    //   else{
    //     totalCost = totalCost + freight;
    //   }
    //   }
    if(this.secondFormGroup.get('quoteLineItemFreight')?.value != null){

      console.log("hi")
      const freight = this.secondFormGroup.get('quoteLineItemFreight')?.value

      if(freight.length > 0){

        freight.forEach((item: { freightValue: string; freightType: string; }) => {
          const freightValue = this.round3(parseFloat(item.freightValue));
          if (item.freightType === 'percentage') {
            const inc = this.round3((freightValue / 100) * totalCost);
            totalCost = this.round3(totalCost + inc); // Apply percentage freight increment
            totalFreightAmount = this.round3(totalFreightAmount + inc);
          } else if (item.freightType === 'amount') {
            totalCost = this.round3(totalCost + freightValue); // Add flat freight amount
            totalFreightAmount = this.round3(totalFreightAmount + freightValue);
          }
        });

      }

      }


    if(this.secondFormGroup.get('quoteLineItemApplicableTaxProfile')?.value != null ){

      const selectedTaxId = this.secondFormGroup.get('quoteLineItemApplicableTaxProfile')?.value;

      const selectedTaxProfile = this.taxStatusData.find(tax => tax.taxId === Number(selectedTaxId));



      if (selectedTaxProfile && selectedTaxProfile.taxPercentage) {
        taxPercentage = parseFloat(selectedTaxProfile.taxPercentage);
      }


      // Check if valid tax percentage
      if (!isNaN(taxPercentage) && taxPercentage > 0) {
        taxAmount = this.round3((subTotalCost * taxPercentage) / 100);
        totalCost = this.round3(totalCost + taxAmount);
      }
    }

    console.log(this.secondFormGroup.get('quoteLineItemFreightTotal')?.value,totalFreightAmount,'totalFreightAmount')

    this.secondFormGroup.get('quoteLineItemTaxAmount')?.setValue(this.round3(taxAmount), { emitEvent: false });

    this.secondFormGroup.get('quoteLineItemFreightTotal')?.setValue(this.round3(totalFreightAmount), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemListPriceSubtotal')?.setValue(this.round3(totalUnitCost), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemDiscount')?.setValue(this.round3(totalDiscount), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemSubtotal')?.setValue(this.round3(subTotalCost), { emitEvent: false });
    this.secondFormGroup.get('quoteLineItemTotal')?.setValue(this.round3(totalCost), { emitEvent: false });



  }

  calculateTaxAmount(index: number): void {

    const form = this.lineItemtableForm.get('rows') as FormArray;

    const row = form.at(index);

    console.log(index, row)
    if (!row) {
      console.error(`No row found at index ${index}`);
      return;
    }

    const quantity = parseFloat(row.get('supplierQuantity')?.value || '0');
    const unitCost = parseFloat(row.get('unitCost')?.value || '0');
    const discount = parseFloat(row.get('discount')?.value || '0');

    const discountedUnitPrice = this.round3(unitCost * (1 - discount / 100));
    const totalCost = this.round3(quantity * discountedUnitPrice);

    row.get('discountedUnitPrice')?.setValue(discountedUnitPrice, { emitEvent: false });
    row.get('totalCost')?.setValue(totalCost, { emitEvent: false });

    this.calculateCostSummary()

  }


  populateForm(data: any[]) {
    console.log(data)
    data.forEach(item => {
      this.addRow(item);
    });
  }
  allowOnlyLetters(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    // Allow A-Z, a-z and space
    if (
      !(charCode >= 65 && charCode <= 90) &&  // uppercase letters
      !(charCode >= 97 && charCode <= 122) && // lowercase letters
      !(charCode === 32)                      // space
    ) {
      event.preventDefault();
    }
  }

  addRow(data: any) {

    // const discountedUnitPrice = this.calculateDiscountedUnitPrice(data);
    // const totalCost = this.calculateTotalCost(data, discountedUnitPrice);

    const row = this._formBuilder.group({
      id: [data.id || null],
      position: [data.position || ''],
      serviceName: [data.serviceName || ''],
      serviceDescription: [data.serviceDescription || ''],
      buyerComment: [data.buyerComment || ''],
      supplierComment: [data.supplierComment || ''],
      attachments: [data.attachments || []],
      uom: [data.uom || ''],
      supplierUom: [data.supplierUom || ''],
      quantity: [data.quantity || 0],
      // supplierQuantity: [data.quantity || 0],
      supplierQuantity: [data.supplierQuantity || 0],
      unitCost: [this.round3(data.price || 0.0), Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedUnitCost: [this.round3(data.price || 0.0)],
      discount: [Number(data.discount || 0.0), Validators.pattern(/^\d+(\.\d+)?$/)],
      discountedUnitPrice: [this.round3(data.discountedUnitPrice || 0.0), Validators.pattern(/^\d+(\.\d+)?$/)],
      totalCost: [this.round3(data.totalCost || 0.0), Validators.pattern(/^\d+(\.\d+)?$/)],
      requestedTotalCost:[this.round3(data.totalCost || 0.0)],
      isActive: [data.isActive ],
      declineReasonTypeId : [data.declineReasonTypeId || null],
      delineOtherReason:[data.delineOtherReason || ''],
      declineReasonDescription:[data.declineReasonDescription || ''],
      leadTime: [data.leadTime || 0],

      isNew: [data.isNew || 0],

    });

    console.log(this.lineItemtableForm.get('rows'),'test 1')

    // this.setupRowListeners(row);
    this.rows.push(row); // Add the row to the FormArray

    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }


  addNewLineItem(){

    const obj = {
      position: this.dataSource.length+1,
      id: null,
      serviceName: null,
      serviceDescription: null,
      buyerComment: null,
      supplierComment: '',
      attachments: [],
      uom: null,
      quantity: 0,
      supplierUom:null,
      supplierQuantity:0,
      unitCost: 0,
      discount: 0,
      totalCost: 0,
      isActive:1,
      isNew: 1,

    }

    // const obj = {
    //   position: this.dataSource.length + 1,   // Increment position based on the length of dataSource
    //   id: null,
    //   serviceName: null,
    //   serviceDescription: null,
    //   buyerComment: null,
    //   supplierComment: '',
    //   attachments: [],
    //   uom: null,
    //   quantity: 0,
    //   supplierUom: null,
    //   supplierQuantity: 0,
    //   price:0,
    //   discount:null,
    //   totalCost: null,
    //   isActive: true,
    //   isNew: true
    // };


    this.addRow(obj)
    this.dataSource = [...this.dataSource, obj];
    // this.dataSource = lineItemData

    console.log(this.lineItemtableForm.get('rows'),'test 2',this.dataSource)
  }

  get rows(): FormArray {
    return this.lineItemtableForm.get('rows') as FormArray;
  }

  async prefillRfqLineItems() {

    if(this.serviceRfqId){

      this.fullLoaderService.showLoader();

      let params = {rfqId:this.serviceRfqId, supplierId:Number(this.cookieService.get('userId'))}

      const data = await this.quoteService.fetchRfqLineItemDetails(params)

      if( data &&  data.length > 0){

        this.dataSource = []

        const lineItemData = data;

        lineItemData.forEach((item: any, index: any) => {
          const obj = {
            position: index + 1,
            id: null,
            serviceName: item.serviceName,
            serviceDescription: item.serviceDescription,
            buyerComment: item.buyerComments,
            supplierComment: '',
            attachments: '',
            uom: item.uom,
            quantity: item.quantity,
            supplierUom:'',
            supplierQuantity:'',
            unitCost: item.unitCost,
            discount: item.discount,
            totalCost: item.price,
            isActive:item.isActive

          }



          this.dataSource.push(obj);


      })


      }

      this.populateForm(this.dataSource);
      this.fullLoaderService.hideLoader()


      }





  }
  async fetchRfqDetails(){
      // this.fullLoaderService.showLoader()
      let paramsData = {rfqId:this.serviceRfqId, supplierId:Number(this.cookieService.get('userId'))}
      const data = await this.quoteService.fetchRfqDetails(paramsData)
      this.headerData = data.rfqData[0]
      this.fullLoaderService.hideLoader()
  }

  async rfqActions(action:string){

    if(action == 'download'){

    this.fullLoaderService.showLoader()

    let fileName = this.headerData?.rfqRefNumber +'.pdf';

    let data = {
      supplierId: Number(this.cookieService.get("userId")),
      rfqId: this.serviceRfqId
    }
    const pdf = await this.SettingsService.generateSupplierRfqAttachment(data)

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()
    }

    else if(action == 'decline'){

      this.showDeclineConfirmationDialogue = true

    }

    else if(action == 'acknowledge'){

      this.fullLoaderService.showLoader()

      let data = {
        operation:action,
        selectedRfqId : [this.headerData.supplierRfqId]
      }

      await this.SettingsService.rfqOperations(data)
      this.fullLoaderService.hideLoader()
      this.snack.open('RFQ has been acknowledged', 'OK', {
        duration: 3000,
      });

    }
    this.fetchRfqDetails()
  }

  async selectMatTabLink(tabItem:any){

    try { await this.save(); } catch (e) { console.error('Auto-save failed:', e); }
    this.fullLoaderService.showLoader();

    if (tabItem.route == 'header') {
       this.activatedRoute.queryParams.subscribe(async params => {

          if (params['serviceRfqId'] != '' && params['quoteId'] != '' && params['servicePurchaseOrderId']!='') {

            this.serviceRfqId = params['serviceRfqId']
            this.quoteId = params['quoteId']
            this.servicePurchaseOrderId = params['servicePurchaseOrderId']

            this.router.navigate([
              "operations", "createServiceOrder", 'header'
            ],
              {
                queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId, servicePurchaseOrderId:this.servicePurchaseOrderId }

              }
            );

          }

        })

      // if (this.isSaved) {

      //   this.activatedRoute.queryParams.subscribe(async params => {

      //     if (params['serviceRfqId'] != '' && params['quoteId'] != '') {

      //       this.serviceRfqId = params['serviceRfqId']
      //       this.quoteId = params['quoteId']

      //       this.router.navigate([
      //         "operations", "createServiceOrder", 'header'
      //       ],
      //         {
      //           queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId }

      //         }
      //       );

      //     }

      //   })
      // }

      // else {
      //   this.snack.open(`please save the 'Header' tab first`, "OK", { duration: 3000 });
      // }
    }

    else if (tabItem.route == 'payment-terms') {

      // if (this.tabEnabled) {

      //   this.activatedRoute.queryParams.subscribe(async params => {

      //     if (params['serviceRfqId'] != '' && params['quoteId'] != '') {

      //       this.serviceRfqId = params['serviceRfqId']
      //       this.quoteId = params['quoteId']


      //       this.router.navigate([
      //         "dashboard", "quote", "create", 'payment-terms'
      //       ],
      //         {
      //           queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId }
      //         }
      //       );

      //     }

      //   })

      // }
      // else {
      //   this.snack.open(`please save the 'Line item' tab first`, "OK", { duration: 3000 });
      // }

      // if (this.isSaved) {

      //   this.activatedRoute.queryParams.subscribe(async params => {

      //     if (params['serviceRfqId'] != '' && params['quoteId'] != '') {

      //       this.serviceRfqId = params['serviceRfqId']
      //       this.quoteId = params['quoteId']


      //       this.router.navigate([
      //         "dashboard", "createServiceOrder", 'payment-terms'
      //       ],
      //         {
      //           queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId }
      //         }
      //       );

      //     }

      //   })

      // }
      // else {
      //   this.snack.open(`please save the 'Line item' tab first`, "OK", { duration: 3000 });
      // }

      this.activatedRoute.queryParams.subscribe(async params => {

          if (params['serviceRfqId'] != '' && params['quoteId'] != '' && params['servicePurchaseOrderId']!='') {

            this.serviceRfqId = params['serviceRfqId']
            this.quoteId = params['quoteId']
            this.servicePurchaseOrderId = params['servicePurchaseOrderId']


            this.router.navigate([
              "operations", "createServiceOrder", 'payment-terms'
            ],
              {
                queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId, servicePurchaseOrderId: this.servicePurchaseOrderId }
              }
            );

          }

        })
    }else if (tabItem.route == 'preview'){
      // if (this.isSaved) {

      //   this.activatedRoute.queryParams.subscribe(async params => {

      //     if (params['serviceRfqId'] != '' && params['quoteId'] != '' && params['servicePurchaseOrderId']) {

      //       this.serviceRfqId = params['serviceRfqId']
      //       this.quoteId = params['quoteId']


      //       this.router.navigate([
      //         "dashboard", "createServiceOrder", 'preview'
      //       ],
      //         {
      //           queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId }
      //         }
      //       );

      //     }

      //   })

      // }
      // else {
      //   this.snack.open(`please save the 'Line item' tab first`, "OK", { duration: 3000 });
      // }

      this.activatedRoute.queryParams.subscribe(async params => {

          if (params['serviceRfqId'] != '' && params['quoteId'] != '' && params['servicePurchaseOrderId']!='') {

            this.serviceRfqId = params['serviceRfqId']
            this.quoteId = params['quoteId']
            this.servicePurchaseOrderId = params['servicePurchaseOrderId']

            this.router.navigate([
              "operations", "createServiceOrder", 'preview'
            ],
              {
                queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId, servicePurchaseOrderId: this.servicePurchaseOrderId }
              }
            );

          }

        })
    }
  }

  async checkisTabEnabled() {

    // const data2 = await this.quoteService.getQuoteDraftData('tab1', this.quoteId)

    // if (data2 && data2.length > 0 && Object.keys(data2[0]).length > 0 && data2[0].rfqLineItemDetails.length > 0) {

    //   this.tabEnabled = true

    // }

  }

  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true
    }
    else {
      this.showCloseDialogue = true

    }

  }

  cancel() {
    this.showConfirmationDialogue = false
    this.showCloseDialogue = false
    this.showCloseDialogueFreight = false
    this.router.navigate(['/operations/buyer-service-quote-list']);
  }

  toggleShowHeaderDetails(event: { checked: boolean }) {
    this.showDetailSection = event.checked;
    // setTimeout(() => {
    //   if (this.table) {
    //     this.table.recalculate();
    //   }
    // }, 100);
  }

  toggleSidebar(value:boolean, section:string,index?:number){



    if(section == 'attachment'){
      this.showAddDocumentSection = value
      if(index !== undefined){
        this.selectedLineItemIndex = index
      }
    }
    else if(section == 'cost'){
      this.showAddCostSection = value
    }else if(section == 'freight'){
      this.showCloseDialogueFreight=value
    }else if(section == 'decline'){

      if(index !== undefined){

        const rows = this.lineItemtableForm.get('rows') as FormArray;

        const selectedRow = rows.at(index);


        if (selectedRow.value.isNew === 1) {

          rows.removeAt(index);

          console.log(this.lineItemtableForm.get('rows') as FormArray,this.dataSource,'removed')

          this.dataSource.splice(index, 1);

          this.dataSource = [...this.dataSource];

          this.snack.open(`New line item removed.`, "OK", { duration: 3000 });

          this.calculateCostSummary()
        }

        else{
          this.selectedLineItemIndex = index
          this.showDeclineSection = value
        }



      }
    }
  }

  fileOver(event:any) {
  }
  fileLeave(event:any) {
  }

  // ===== Freight Forwarder helpers (Packaging/Mode filtering) =====
  async fetchModeofTransportByUserId(){
    try{
      const result = await this.SettingsService.fetchModeofTransportByUserId(Number(this.cookieService.get('userId')));
      this.availableModes = result;
      this.allAvailableModes = result;
    }catch(err){
      console.log(err);
    }
  }

  async fetchPackagingByUserId(){
    try{
      const result = await this.SettingsService.fetchPackagingByUserId(Number(this.cookieService.get('userId')));
      this.availablePackaging = result;
      this.allAvailablePackaging = result;
    }catch(err){
      console.log(err);
    }
  }

  onFreightForwarderSelected(value: any) {
    const selectedFreightForwarder = (this.freightForwarders || []).find((ff: any) => ff.id === value);
    this.selectedFreightForwarder = selectedFreightForwarder;

    // Propagate selected FF into sub-forms so additions can be linked
    this.modeOfTransportFormGroup.patchValue({ freightForwarderId: value });
    this.packagingFormGroup.patchValue({ freightForwarderId: value });

    // Reset selections when FF changes
    this.freightForwarderForm.patchValue({ modeOfTransport: null, packaging: null });

    // Filter modes
    let modeIds: number[] = [];
    const mot: any = selectedFreightForwarder?.modeOfTransportId;
    if (Array.isArray(mot)) {
      modeIds = mot.map((x: any) => Number(x)).filter((n: number) => !isNaN(n));
    } else if (typeof mot === 'string') {
      modeIds = mot.split(',').map((s: string) => Number((s || '').trim())).filter((n: number) => !isNaN(n));
    } else if (mot != null) {
      const n = Number(mot);
      if (!isNaN(n)) modeIds = [n];
    }
    if (modeIds.length > 0) {
      this.availableModes = (this.allAvailableModes || []).filter((m: any) => modeIds.includes(m.id));
    } else {
      this.availableModes = [];
    }

    // Filter packaging
    let packagingIds: number[] = [];
    const pkg: any = selectedFreightForwarder?.packagingId;
    if (Array.isArray(pkg)) {
      packagingIds = pkg.map((x: any) => Number(x)).filter((n: number) => !isNaN(n));
    } else if (typeof pkg === 'string') {
      packagingIds = pkg.split(',').map((s: string) => Number((s || '').trim())).filter((n: number) => !isNaN(n));
    } else if (pkg != null) {
      const n = Number(pkg);
      if (!isNaN(n)) packagingIds = [n];
    }
    if (packagingIds.length > 0) {
      this.availablePackaging = (this.allAvailablePackaging || []).filter((p: any) => packagingIds.includes(p.id));
    } else {
      this.availablePackaging = [];
    }
  }

  // Toggle sub-sidebar open/close for adding Mode of Transport or Packaging
  toggleSubSideBar(value: boolean, section: string) {
    if (value) {
      this.currentSubForm = section;
    } else {
      this.currentSubForm = '';
    }
    this.showSubSidebar = value;
  }

  // Refresh freight forwarders list
  private async fetchFreightForwarderByUserId() {
    const result = await this.SettingsService.fetchFreightForwarderByUserId(Number(this.cookieService.get('userId')));
    this.freightForwarders = result.rows || result;
  }

  // Handle checkbox change for Mode of Transport
  onModeOfTransportCheckBoxChange(event: any) {
    let values: any[] = [];
    const selected = event?.source?.selected;

    if (Array.isArray(selected)) {
      values = selected.map((option: any) => option.value);
    } else if (selected && selected.value !== undefined) {
      values = [selected.value];
    } else if (Array.isArray(event?.value)) {
      values = event.value;
    } else if (event?.value !== undefined && event?.value !== null) {
      values = [event.value];
    }

    this.selectedModes = values;
    console.log("selectedModes", this.selectedModes);
    if (this.selectedModes.length > 0) {
      this.freightForwarderForm.get('modeOfTransportId')?.setValue(this.selectedModes[0]);
      this.freightForwarderForm.get('modeOfTransport')?.setValue(this.selectedModes);
    } else {
      this.freightForwarderForm.get('modeOfTransport')?.reset();
    }
  }

  // Handle checkbox change for Packaging
  onPackagingCheckBoxChange(event: any) {
    let values: any[] = [];
    const selected = event?.source?.selected;

    if (Array.isArray(selected)) {
      values = selected.map((option: any) => option.value);
    } else if (selected && selected.value !== undefined) {
      values = [selected.value];
    } else if (Array.isArray(event?.value)) {
      values = event.value;
    } else if (event?.value !== undefined && event?.value !== null) {
      values = [event.value];
    }

    this.selectedPackaging = values;
    if (this.selectedPackaging.length > 0) {
      this.freightForwarderForm.get('packagingId')?.setValue(this.selectedPackaging[0]);
      this.freightForwarderForm.get('packaging')?.setValue(this.selectedPackaging);
    } else {
      this.freightForwarderForm.get('packaging')?.reset();
    }
  }

  // Save new Mode of Transport or Packaging and refresh lists
  async saveForm(section: string) {
    try {
      this.fullLoaderService.showLoader();
      if (section === 'modeOfTransport') {
        const formData = this.modeOfTransportFormGroup.value;
        console.log("ModeOfTransport formData",formData)
        if (this.modeOfTransportFormGroup.get('freightForwarderId')?.value) {
          await this.SettingsService.addModeOfTransportToFreightForwarder(formData);
          await this.fetchFreightForwarderByUserId();
        } else {
          await this.SettingsService.addModeOfTransport(formData);
        }
        await this.fetchModeofTransportByUserId();

        // If an FF is selected, re-apply filtering to include new item
        const ffId = this.freightForwarderForm.get('freightForwarderId')?.value;
        if (ffId) {
          this.onFreightForwarderSelected(ffId);
        }

        this.toggleSubSideBar(false, 'modeOfTransport');
        this.modeOfTransportFormGroup.get('modeOfTransport')?.reset();
        this.snack.open('Mode Of Transport Added Successfully!', 'OK', { duration: 3000 });
      } else if (section === 'packaging') {
        const formData = this.packagingFormGroup.value;
        if (this.packagingFormGroup.get('freightForwarderId')?.value) {
          await this.SettingsService.addPackagingToFreightForwarder(formData);
          await this.fetchFreightForwarderByUserId();
        } else {
          await this.SettingsService.addPackaging(formData);
        }
        await this.fetchPackagingByUserId();

        // If an FF is selected, re-apply filtering to include new item
        const ffId = this.freightForwarderForm.get('freightForwarderId')?.value;
        if (ffId) {
          this.onFreightForwarderSelected(ffId);
        }

        this.toggleSubSideBar(false, 'packaging');
        this.packagingFormGroup.get('packaging')?.reset();
        this.snack.open('Packaging Added Successfully!', 'OK', { duration: 3000 });
      }
    } catch (err: any) {
      console.error(err);
      this.snack.open(err?.message || 'Failed to save.', 'OK', { duration: 3000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  async onAttachmentChange(files: NgxFileDropEntry[]) {
    try{


      const rows = this.lineItemtableForm.get('rows') as FormArray;

      if (this.selectedAttachmentType == undefined || this.selectedAttachmentType == null) {

        this.snack.open('Please select the attachment type.', 'OK', {
          duration: 3000,
        });
        return;

      }

      this.newfileuploaded = true;
      this.fullLoaderService.showLoader();

      if(this.selectedLineItemIndex!=null){

        this.uploadedAttachmentsArray = rows.at(this.selectedLineItemIndex).get('attachments')?.value || [];

        if (this.uploadedAttachmentsArray.length > 5) {

        throw new Error('Maximum 5 files allowed for a product!');
         }

      const fileEntries = files
        .filter((entry) => entry.fileEntry.isFile)
        .map((ele) => ele.fileEntry as FileSystemFileEntry);

        console.log(fileEntries,"fileEntries")

      if (fileEntries.length === 0) {
        throw new Error('Please upload valid files!');
      }
      if (fileEntries.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      await new Promise((res, rej) => {
        fileEntries.map((fileEntry) => {
          fileEntry.file(async(file) => {
            let fileExt = file.name.split('.').pop();
            if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
              // rej('Invalid filetype!');
              return;
            }

            if (file.size > this.maxFileSize) {
              throw new Error('File size must be less than 5MB!')
            }

            let uploadedAttachment:any = {
              lineItemIndex:this.selectedLineItemIndex,
              dataUrl:'',
              name:file.name,
              file:file,
              attachmentType: this.selectedAttachmentType,
              hazardousDeclaration:this.hazardousDeclaration
            }

            await new Promise((res,rej)=>{
              const reader = new FileReader();
              reader.onload = (e: any) => {
                uploadedAttachment.dataUrl = e.target.result; // Store the data URL for preview
                res(true)
              };
              reader.readAsDataURL(file); // Read the file as a data URL
            })

            this.uploadedAttachmentsArray.push(uploadedAttachment);
            res(file);
          });
        });
      });

      rows.at(this.selectedLineItemIndex).patchValue({
        attachments: this.uploadedAttachmentsArray
      });
      console.log( rows.at(this.selectedLineItemIndex).get('attachments')?.value,this.uploadedAttachmentsArray)

      this.fullLoaderService.hideLoader();
    }
  }catch(error:any){
    this.snack.open(error, 'OK', {
      duration: 1000,
    });
  }
  }

  onDeclineReasonChange(event: MatSelectChange){

    const selectedValue = event.value;

    if(selectedValue=='7'){
      this.showOtherReason = true
    }
    else{
      this.showOtherReason = false
    }
  }


  onAttachmentTypeChange(event: MatSelectChange){

    const selectedValue = event.value;

    // No hazardous declaration handling for services
  }

  toggleWrapDescription(event: MatSlideToggleChange) {
    this.isWrapDescription = event.checked;
  }

  declineLineItem(){

    const rows = this.lineItemtableForm.get('rows') as FormArray;


    if(this.declineReason ==undefined || this.declineReason ==null ){

      this.snack.open('Please select the decline reason.', 'OK', {
        duration: 3000,
      });
      return;

  }

      if( this.declineReason == 7 && (this.otherReason == null || this.otherReason == '')){

        this.snack.open('Other reason can not be empty.', 'OK', {
          duration: 3000,
        });

        return;

    }

      const reason = this.delineReasonData.find(item => item.id === this.declineReason);

      const reasonDesc = reason ? reason.reasonDescription : 'Reason not found';

      if(this.selectedLineItemIndex!=null){


        // const selectedRow = rows.at(this.selectedLineItemIndex);


        // if (selectedRow.value.isNew === 1) {

        //   rows.removeAt(this.selectedLineItemIndex);

        //   console.log(this.lineItemtableForm.get('rows') as FormArray,this.dataSource,'removed')

        //   this.dataSource.splice(this.selectedLineItemIndex, 1);
        //     // Trigger change detection if you're using MatTable
        //   this.dataSource = [...this.dataSource];

        //   this.snack.open(`New line item removed.`, "OK", { duration: 3000 });
        // }
        // else {

        rows.at(this.selectedLineItemIndex).patchValue({
          isActive: 0,
          declineReasonTypeId : this.declineReason,
          delineOtherReason: this.otherReason,
          declineReasonDescription: reasonDesc,
          attachments:[],
          supplierQuantity:0

        });

        this.snack.open(`Line Item Declined, selected line item attachments are removed`, "OK", { duration: 3000 });

        }
      // }


      this.showDeclineSection = false
      this.declineReason = null
      this.otherReason = ''
      this.selectedLineItemIndex = null

      this.calculateCostSummary()

  }

  restoreLineitem(index:number){

    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const quantityValue = rows.at(index).get('quantity')?.value;

    rows.at(index).patchValue({
      isActive: 1,
      declineReasonTypeId :null,
      delineOtherReason: null,
      declineReasonDescription: null,
      supplierQuantity:quantityValue || 1

    });

    this.snack.open(`Line Item Restored`, "OK", { duration: 3000 });

    this.calculateCostSummary()

  }

  isDecline(index:number){

    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    // Get the value of the 'isActive' field
    const isActive = row.get('isActive')?.value;

    // Return the value (true or false)
    return isActive === 0;
  }

  getDeclineReason(index:number){

    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    // Get the value of the 'isActive' field
    const reason = row.get('declineReasonDescription')?.value || '';

    return `Declined - ${reason || 'No reason provided'}`;

  }

  isNew(index:number){

    const rows = this.lineItemtableForm.get('rows') as FormArray;

    const row = rows.at(index);

    const isNew = row.get('isNew')?.value;

    // Return the value (true or false)
    return isNew === 1;
  }

  saveAdditionalCost(){


    if(this.freightDescription =='' || this.freightType =='' || this.freightValue ==null ){

      this.snack.open('Please fill the additional cost details.', 'OK', {
        duration: 3000,
      });
      return;

     }
      let params = {
        id:null,
        freightDescription: this.freightDescription,
        freightType: this.freightType,
        freightValue: this.freightValue,
        isActive:1
      }
      console.log('params',params);
      this.addedAdditionalCost.push(params)

      this.secondFormGroup.get('quoteLineItemFreight')?.setValue(this.addedAdditionalCost)

      console.log(this.addedAdditionalCost)
      console.log(this.secondFormGroup);
      console.log('test',this.secondFormGroup.get('quoteLineItemFreight')?.value);
      this.calculateCostSummary()

      this.showAddCostSection = false
      this.freightDescription = ''
      this.freightType = 'amount'
      this.freightValue = null



  }


  async getQuoteDraftData() {

    this.fullLoaderService.showLoader()

    // const data = await this.quoteService.getQuoteDraftData('tab2', Number(this.quoteId))
    let params = {
      purchaseOrderId:this.servicePurchaseOrderId,
      section:"lineItems"
    }
    const data = await this.SettingsService.fetchServicePurchaseOrder(params);

    console.log({data});

      if (data && data.length > 0 && Object.keys(data[0]).length > 0 && data[0].quotationLineItems.length > 0) {


        if ( data[0].quotationLineItems[0].quoteLineItemDetailsId) {
          this.isSaved = true
        }

        this.secondFormGroup.patchValue({


          quoteLineItemHeaderId:data[0].quoteLineItemHeaderId || '',
          quoteLineItemListPriceSubtotal:data[0].lineItemListPriceSubtotal || '',
          quoteLineItemDiscount:data[0].lineItemDiscount || '',
          quoteLineItemSubtotal :data[0].lineItemSubtotal || '',
          quoteLineItemGeneralDiscountType :data[0].generalDiscountType || 'percentage',
          quoteLineItemGeneralDiscountValue:data[0].generalDiscountValue || '',
          quoteLineItemFreightTotal:data[0].lineItemFreightTotal || '',
          quoteLineItemFreight:data[0].quoteLineItemFreight || '',
          quoteLineItemTotal :data[0].lineItemTotal || '',
          supplierCurrency: data[0].currency,
          quoteLineItemApplicableTaxProfile:data[0].lineItemApplicableTaxProfile || null,
          quoteLineItemTaxAmount: data[0].lineItemTaxAmount || 0

        });

        console.log("lineitmefreight",this.secondFormGroup.get('quoteLineItemFreight')?.value);



        this.dataSource = [];

        if (data[0].quotationLineItems && data[0].quotationLineItems.length > 0) {

          data[0].quotationLineItems.forEach((item: {
            leadTime: any;
            attachments: any;
            declineReasonTypeId: any;
            declineReasonDescription: any;
            delineOtherReason: any;
            supplierQuantity: any;
            supplierUom: any;
            uom: any;
            buyerComment: any;
            quoteLineItemDetailsId: any;
            isActive: any;
            serviceName: any; serviceDescription: any; unitCost: any; discount: any; supplierComment: any;  quantity: any; discountedUnitPrice: any; totalCost: any;
             }, index: number) => {
            const obj = {
              position: index + 1, // Assign position based on index
              id: item.quoteLineItemDetailsId,
              serviceName: item.serviceName,
              serviceDescription: item.serviceDescription,
              buyerComment: item.buyerComment,
              supplierComment: item.supplierComment,
              uom: item.uom,
              supplierUom: item.supplierUom,
              quantity: item.quantity,
              supplierQuantity: item.supplierQuantity,
              price: item.unitCost,
              discount: item.discount,
              discountedUnitPrice: item.discountedUnitPrice,
              totalCost:item.totalCost,
              isActive: item.isActive,
              declineReasonTypeId: item.declineReasonTypeId,
              delineOtherReason: item.delineOtherReason,
              declineReasonDescription: item.declineReasonDescription,
              attachments:item.attachments,
              leadTime:item.leadTime,
              isNew:0,


            };



            this.dataSource.push(obj); // Push each object to dataSource

          });

          this.populateForm(this.dataSource);
          // this.toggleSelectAllLineItem(true)



        }

        this.fullLoaderService.hideLoader()

      }



      else {

        this.prefillRfqLineItems()
        this.fetchDefaultCurrency()

      }

      this.fullLoaderService.hideLoader()

  }


  // Function that dismisses the notification
  dismissNotification() {
    this.showNotification = false;
  }

// Function to display the notification with missing fields
showMissingFieldsNotification(missingFields: { section: string, fields: string[] }[]) {
  let message = '<strong>Please fill all the missing fields before proceeding:</strong><br><br>';

  // Loop through each section and list its missing fields
  missingFields.forEach(missingField => {
    message += `<strong>${missingField.section}:</strong><br>`; // Add section name
    message += missingField.fields.map(field => `  • ${field}`).join('<br>'); // List missing fields with bullet points
    message += '<br><br>'; // Add extra spacing between sections
  });

  this.notificationMessage = message;
  this.notificationTitle = 'Missing Fields';
  this.notificationType = 'error'; // Change this to 'info' for informational notifications
  this.showNotification = true; // Display the notification
}



  // // Validation logic to check for required fields
  // isValidRequiredFields(): { section: string, fields: string[] }[] {
  //   console.log("isValidRequiredFields called")
  //   const missingFields: { section: string, fields: string[] }[] = [];

  //   // Check for missing fields in Tab1 (Line Items Section)
  //   const lineItemMissingFields: string[] = [];
  //   // const lineItems = this.secondFormGroup.value;
  //   const lineItems = this.lineItemtableForm.value.rows
  //   console.log({lineItems});
  //   if (!lineItems.unitCost || lineItems.unitCost <= 0) {
  //     lineItemMissingFields.push('Unit Cost for line item');
  //   }
  //   if (!lineItems.leadTime || lineItems.leadTime <= 0) {
  //     lineItemMissingFields.push('Lead Time for line item');
  //   }

  //   if (lineItemMissingFields.length > 0) {
  //     missingFields.push({ section: 'Line Items', fields: lineItemMissingFields });
  //   }

  //   // Show notification if there are missing fields
  //   if (missingFields.length > 0) {
  //     this.showMissingFieldsNotification(missingFields);
  //   }

  //   return missingFields;
  // }

  isValidRequiredFields(): { section: string, fields: string[] }[] {
  const missingFields: { section: string, fields: string[] }[] = [];

  // Check for missing fields in Tab1 (Line Items Section)
  const lineItemMissingFields: string[] = [];
  const lineItems = this.lineItemtableForm.value?.rows || [];

  lineItems.forEach((item: any, index: number) => {
    if (!item.unitCost || item.unitCost <= 0) {
      lineItemMissingFields.push(`Unit Cost for line item #${index + 1}`);
    }
    if (!item.leadTime || item.leadTime <= 0) {
      lineItemMissingFields.push(`Lead Time for line item #${index + 1}`);
    }
  });
  const form = this.secondFormGroup;

  if (!form.get('supplierCurrency')?.value) {
    lineItemMissingFields.push('Preferred Currency');
  }

  if (lineItemMissingFields.length > 0) {
    missingFields.push({ section: 'Line Items', fields: lineItemMissingFields });
  }

  // Show notification if there are missing fields
  if (missingFields.length > 0) {
    this.showMissingFieldsNotification(missingFields);
  }

  return missingFields;
}


  getLineItemAttachment(){

    const rows = this.lineItemtableForm.value.rows

    if(this.selectedLineItemIndex!=null){
      const row = rows[this.selectedLineItemIndex];
      const attachment = row.attachments || []
      // Get the value of the 'isActive' field
       return attachment;
    }
    else{
      return []
    }


  }

  filterFieldCurrencyNameDisplayFn(_currency: Currency) {
    return _currency ? `${_currency.currencyCode}` : undefined;
  }

  getCurrencyFilterKeyDataObservable(pageMeta: Page) {
    pageMeta.serachParam =
      pageMeta.serachParam || pageMeta.serachParam == ''
        ? pageMeta.serachParam
        : this.searchKeyParams;
    this.searchKeyParams = pageMeta.serachParam;
    return this.SettingsService.getAllCurrenciesByFliterKeyValue(
      pageMeta.serachParam,
      pageMeta
    );
  }


  getCurrencyControl(): any {
    return this.secondFormGroup.get('supplierCurrency') as FormControl;
  }


  async getTaxDetails() {
    this.fullLoaderService.showLoader();
    let data = {
      supplierId: Number(this.cookieService.get('userId')),
    };
    const response = await this.SettingsService.getTaxDetailsBySupplier(data);
    this.taxStatusData = response.rows;
    this.fullLoaderService.hideLoader();
  }

  async fetchDefaultCurrency(){

    const transactionSetupdata = await this.SettingsService.fetchSupplierSetup('TransactionSetup',Number(this.CookieService.get('userId')))

      if(transactionSetupdata.length > 0 ){

        this.secondFormGroup.patchValue({
          supplierCurrency: {
            id:transactionSetupdata[0].default_currency,
            currencyName:transactionSetupdata[0].currencyName,
            currencyCode:transactionSetupdata[0].currencyCode,
            currencySymbol:transactionSetupdata[0].currencySymbol
          },
        });


  }
  }

  async togglePreview(value:boolean,section:string,docs?:any){
    this.previewSection=value;
    this.previewDocs = []
    if(docs){
      if(section == 'single'){
         this.previewDocs.push(docs)
      }
      else if(section == 'multiple'){
        this.previewDocs = docs
      }
    }
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.previewDocs.length;
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.previewDocs.length) %
      this.previewDocs.length;
  }

  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) {
      return true; // For data URLs, check if the MIME type is 'application/pdf'
    }
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf'); // For URLs, check if it ends with '.pdf'
  }


  // Optional: You can implement logic to show more info when the info icon is clicked.
  showInfo(): void {
    // Logic to show additional info (e.g., a dialog, alert, or modal)
    console.log("Info icon clicked - show additional info!");
  }


}
